export default __webpack_public_path__ + "static/media/unlock-data-chart.c20f4e80.svg";